import { useSubscriptionContext } from '@/modules/subscriptions/context/SubscriptionProvider';

export function useSubscription() {
  return useSubscriptionContext();
}